/* "New in {category}" landing-page sidebar.
   Each <aside data-bk-new-in="<collection handle>"> starts as a skeleton; this fetches the
   bk-new-in-category section (newest-first, in stock) through the Section Rendering API and
   swaps it in. On any error, or fewer than 2 product cards, the aside is removed entirely so
   the layout collapses to the single content column. */
(function () {
  'use strict';
  var asides = document.querySelectorAll('.bk-landing-template__aside[data-bk-new-in]');
  if (!asides.length || typeof window.fetch !== 'function') return;

  function load(aside) {
    var handle = aside.getAttribute('data-bk-new-in');
    if (!handle) { aside.remove(); return; }
    var url = '/collections/' + encodeURIComponent(handle) +
      '?sort_by=created-descending&filter.v.availability=1&sections=bk-new-in-category';
    // No Accept: application/json header: Shopify then answers with the collection JSON
    // and ignores ?sections=. The sections endpoint already returns JSON on its own.
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
      .then(function (json) {
        // The Section Rendering API answers {"<section-id>": "<html>"} (flat); tolerate a
        // nested {"sections": {...}} shape too.
        var html = json && (json['bk-new-in-category'] ||
          (json.sections && json.sections['bk-new-in-category']));
        if (!html) throw new Error('section missing');
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        var cards = tpl.content.querySelectorAll('.bk-product-card');
        if (cards.length < 2) throw new Error('too few products');
        var block = tpl.content.querySelector('.bk-new-in') || tpl.content;
        aside.replaceChildren(block);
        aside.removeAttribute('aria-busy');
        aside.setAttribute('data-bk-new-in-state', 'loaded');
        aside.setAttribute('data-bk-new-in-count', String(cards.length));
      })
      .catch(function () { aside.remove(); });
  }

  Array.prototype.forEach.call(asides, load);
})();
